// Mock data & business config for Ichi and Ori Pet Care
// All images below are REAL Ichi & Ori photos (facility, team, grooming, pets)

const ASSET = 'https://customer-assets.emergentagent.com/job_petcare-preview-1/artifacts';

// ---------- IMAGE LIBRARY (categorised) ----------
export const PHOTOS = {
  storefront: [
    `${ASSET}/js313ejq_Front1.jpg`,
    `${ASSET}/ixsrs63c_FRont%202.jpg`,
    `${ASSET}/l82kzrj7_FRont%203.jpg`,
    `${ASSET}/xkr904e2_Front%204.jpg`,
    `${ASSET}/477hs5wi_Full%20View.jpg`,
  ],
  facility: [
    `${ASSET}/siwxre9g_Waiting%20Area.jpg`,
    `${ASSET}/w614bhhl_Waiting%20Area%202.jpg`,
    `${ASSET}/ie955nqa_Passage.jpg`,
    `${ASSET}/vxqih36p_WhatsApp%20Image%202025-07-02%20at%2020.32.36_86ed9b7a.jpg`,
    `${ASSET}/dz5ojpv3_WhatsApp%20Image%202025-07-02%20at%2020.33.52_8001cf02.jpg`,
    `${ASSET}/zxwl21wv_WhatsApp%20Image%202025-07-02%20at%2020.33.58_f0b33e95.jpg`,
    `${ASSET}/iv6xbbnd_WhatsApp%20Image%202025-07-02%20at%2020.34.03_dbda916c.jpg`,
    `${ASSET}/mk9mhr53_WhatsApp%20Image%202025-07-02%20at%2020.34.27_26d4efdc.jpg`,
  ],
  boarding: [
    `${ASSET}/1c1iljbe_WhatsApp%20Image%202025-07-02%20at%2020.41.27_962b7551.jpg`,
    `${ASSET}/i8p2bgy3_WhatsApp%20Image%202025-07-02%20at%2020.41.27_3fa9da50.jpg`,
  ],
  grooming: [
    `${ASSET}/0fq5te81_WhatsApp%20Image%202025-07-02%20at%2020.41.32_949283ad.jpg`,
    `${ASSET}/carwpuev_WhatsApp%20Image%202025-07-02%20at%2020.41.33_2c7354c9.jpg`,
    `${ASSET}/ngrcgbri_WhatsApp%20Image%202025-07-02%20at%2020.41.33_be985b26.jpg`,
    `${ASSET}/c809vxlo_WhatsApp%20Image%202025-07-02%20at%2020.41.33_cb7481e4.jpg`,
    `${ASSET}/jznz9ex5_WhatsApp%20Image%202025-07-02%20at%2020.41.34_03e11a44.jpg`,
    `${ASSET}/uzdahydp_WhatsApp%20Image%202025-07-02%20at%2020.41.34_3e2952ab.jpg`,
    `${ASSET}/ulzi9xd4_WhatsApp%20Image%202025-07-02%20at%2020.41.34_9b36c568.jpg`,
    `${ASSET}/j4xl7ixu_WhatsApp%20Image%202025-07-02%20at%2020.41.35_4f575e75.jpg`,
    `${ASSET}/k43yt2z9_WhatsApp%20Image%202025-07-02%20at%2020.41.35_dce01642.jpg`,
  ],
  team: [
    `${ASSET}/qwjurv0k_WhatsApp%20Image%202025-07-02%20at%2020.41.29_de406bae.jpg`,
    `${ASSET}/e54rgcch_WhatsApp%20Image%202025-07-02%20at%2020.41.29_d78f43a5.jpg`,
    `${ASSET}/ncoib18h_WhatsApp%20Image%202025-07-02%20at%2020.41.29_c6511985.jpg`,
  ],
  retail: [
    `${ASSET}/gww5dq43_WhatsApp%20Image%202025-07-02%20at%2020.35.44_3ebe33ae.jpg`,
    `${ASSET}/9jnehnxk_WhatsApp%20Image%202025-06-28%20at%2018.06.11_cf7dc907.jpg`,
    `${ASSET}/vr11swgm_WhatsApp%20Image%202025-06-28%20at%2018.06.14_ba8a3fee.jpg`,
    `${ASSET}/nmob5b8v_WhatsApp%20Image%202025-06-28%20at%2018.06.16_baf9bf29.jpg`,
    `${ASSET}/m95p0mt4_WhatsApp%20Image%202025-06-28%20at%2018.06.17_17439856.jpg`,
    `${ASSET}/7gz3teq8_WhatsApp%20Image%202025-06-28%20at%2018.06.17_4a72735c.jpg`,
  ],
  happyPets: [
    `${ASSET}/wib7hh7v_WhatsApp%20Image%202026-06-11%20at%2018.56.54.jpeg`,
    `${ASSET}/zjz0vzxv_WhatsApp%20Image%202026-06-11%20at%2018.53.23.jpeg`,
    `${ASSET}/fbikhdkn_WhatsApp%20Image%202026-06-11%20at%2018.53.22%20%282%29.jpeg`,
    `${ASSET}/h0ov83d1_WhatsApp%20Image%202026-06-11%20at%2018.53.24%20%282%29.jpeg`,
    `${ASSET}/bp3molrf_WhatsApp%20Image%202025-06-28%20at%2018.06.19_9c485430.jpg`,
    `${ASSET}/q50m9fao_WhatsApp%20Image%202025-06-28%20at%2018.06.19_28eefb06.jpg`,
    `${ASSET}/xyp7rsas_WhatsApp%20Image%202025-06-28%20at%2018.06.19_a1b11abe.jpg`,
    `${ASSET}/uc1h3yj5_WhatsApp%20Image%202025-06-28%20at%2018.06.20_a1fde54c.jpg`,
    `${ASSET}/x0nwo2wj_WhatsApp%20Image%202025-06-28%20at%2019.03.30_90379cc7.jpg`,
    `${ASSET}/u2jgjrpf_WhatsApp%20Image%202025-06-28%20at%2019.03.30_538598d5.jpg`,
    `${ASSET}/2k6j01ei_WhatsApp%20Image%202025-06-28%20at%2019.03.31_33e49fcf.jpg`,
    `${ASSET}/acho8yr0_WhatsApp%20Image%202025-06-28%20at%2019.03.32_a64e2be2.jpg`,
    `${ASSET}/idrncuhc_WhatsApp%20Image%202025-06-28%20at%2019.03.32_e758f92d.jpg`,
    `${ASSET}/ak5bksam_WhatsApp%20Image%202025-06-28%20at%2019.03.33_dc30de07.jpg`,
  ],
};

// Legacy IMAGES object kept for backward compatibility
export const IMAGES = {
  hero: PHOTOS.facility[0],                  // Waiting Area — dog mural, retail, paw lights
  welcome: PHOTOS.happyPets[3],              // Two dogs with kids
  story1: PHOTOS.happyPets[0],               // Kitten close-up
  story2: PHOTOS.happyPets[2],               // Two goldens
  story3: PHOTOS.happyPets[1],               // Little + big dog
  story4: PHOTOS.happyPets[3],               // Dogs with kids
  facility1: PHOTOS.storefront[0],
  facility2: PHOTOS.facility[0],             // Waiting Area
  facility3: PHOTOS.facility[1],             // Waiting Area 2
  facility4: PHOTOS.facility[2],             // Passage
  facility5: PHOTOS.storefront[4],           // Full View
  grooming: `${ASSET}/sq04fkri_WhatsApp%20Image%202025-07-02%20at%2020.34.03_dbda916c.jpg`,  // Groomer bathing Golden Retriever in stainless-steel tub
  vet: `${ASSET}/lzoeivzx_WhatsApp%20Image%202025-07-02%20at%2020.41.29_de406bae.jpg`,  // Dr. Vivek Sheoran at desk with WSAVA / SAVA credentials
  // Service-page heroes (real photos)
  retailHero: 'https://customer-assets.emergentagent.com/job_petcare-preview-1/artifacts/vr11swgm_WhatsApp%20Image%202025-06-28%20at%2018.06.14_ba8a3fee.jpg',
  boardingHero: `${ASSET}/kj9haifv_WhatsApp%20Image%202025-07-02%20at%2020.41.27_3fa9da50.jpg`,  // Colorful boarding suites with picket-fence doors
  boardingHero2: `${ASSET}/hmb6i0se_WhatsApp%20Image%202025-07-02%20at%2020.41.33_2c7354c9.jpg`, // Staff bonding with Golden Retriever near retail wall
  groomingHero: `${ASSET}/sq04fkri_WhatsApp%20Image%202025-07-02%20at%2020.34.03_dbda916c.jpg`,   // Bath in stainless steel tub — groomer washing Golden Retriever
  groomingHero2: `${ASSET}/eq2h7f1k_WhatsApp%20Image%202025-07-02%20at%2020.35.44_3ebe33ae.jpg`,  // Drying on grooming table — happy Golden
};

// ---------- BUSINESS CONFIG ----------
export const CONTACT = {
  phone: '+91 9560925999',
  phoneRaw: '+919560925999',
  address: 'G11, Tower C, Noida World One, Sector 90, Noida, Uttar Pradesh, India',
  shortAddress: 'Sector 90, Noida, Uttar Pradesh',
  email: 'care@ichiandoripetcare.com',
  hours: 'Mon–Sun: 10:30 AM – 8:00 PM',
  instagram: 'https://instagram.com/ichiandoripetcare',
  facebook: 'https://facebook.com/ichiandoripetcare',
  linkedin: 'https://www.linkedin.com/company/ichi-and-ori-pet-care/',
  googleReviews: 'https://share.google/upQZDO6uF3HIFxIZP',
  mapsEmbed: 'https://www.google.com/maps?q=Noida+World+One+Sector+90+Noida&output=embed',
  mapsLink: 'https://www.google.com/maps?q=Noida+World+One+Sector+90+Noida',
  logo: `${ASSET}/qou8aw4w_Ichi%20%20Ori%20Main%20Logo.png`,
};

// ---------- NAV ----------
export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Contact', path: '/contact' },
];

export const SERVICE_LINKS = [
  { label: 'Veterinary Services', path: '/veterinary' },
  { label: 'Grooming', path: '/grooming' },
  { label: 'Day Boarding', path: '/boarding' },
  { label: 'Retail / Products', path: '/retail' },
];

export const SERVICES = [
  { id: 'veterinary', title: 'Veterinary Care', description: 'Consultations, vaccinations, diagnostics, surgery and preventive healthcare, all under one roof.', link: '/veterinary' },
  { id: 'grooming', title: 'Grooming', description: 'Baths, haircuts, nail trims, ear cleaning and coat-specific styling in a calm, low-stress setting.', link: '/grooming' },
  { id: 'boarding', title: 'Day Boarding', description: 'Supervised day care with individual suites, structured play, feeding as per your routine and photo updates.', link: '/boarding' },
  { id: 'retail', title: 'Pet Retail', description: 'Curated premium nutrition, treats, toys and accessories, selected and used by our own pets first.', link: '/retail' },
];

// ---------- REVIEWS ----------
// Real reviews from Google Business Profile. Replace text below with your top picks.
// Source: https://share.google/upQZDO6uF3HIFxIZP
export const GOOGLE_RATING = { rating: 4.9, count: 107, source: 'Google' };

export const REVIEWS = [
  {
    id: 1,
    name: 'Ayushi Singh',
    initial: 'A',
    rating: 5,
    short: "Great experience with Ichi and Ori Pet Care for my dog Grok's neuter surgery. The whole process was handled very...",
    full: "Great experience with Ichi and Ori Pet Care for my dog Grok's neuter surgery. The whole process was handled very professionally and smoothly, and Grok recovered well under their guidance.\n\nWhat I genuinely liked the most is that the team still checks in from time to time asking about Grok's health updates. It shows they truly care about pets beyond just treatment. That kind of attention and care is rare to find.\n\nHighly recommended for anyone looking for a caring and trustworthy team for their pets.",
  },
  {
    id: 2,
    name: 'Aman Anand',
    initial: 'A',
    rating: 5,
    short: 'I had a wonderful experience with Ichi and Ori Pet Care. I have used both their boarding and grooming services...',
    full: "I had a wonderful experience with Ichi and Ori Pet Care. I have used both their boarding and grooming services, and I am extremely happy with the care and attention provided to my pet.\n\nThe team is professional, friendly, and genuinely passionate about animals. During boarding, I had complete peace of mind knowing my pet was in a safe, clean, and caring environment. The grooming service was equally impressive, and my pet came back looking and feeling great.\n\nI would highly recommend Ichi and Ori Pet Care to any pet parent looking for reliable, trustworthy, and high-quality pet care services. Thank you to the entire team for the excellent experience!",
  },
  {
    id: 3,
    name: 'Vikram Singhaniya',
    initial: 'V',
    rating: 4,
    short: 'I had a really good experience at Ichi and Ori Care. The clinic truly gives a premium feeling from the moment you...',
    full: "I had a really good experience at Ichi and Ori Care. The clinic truly gives a premium feeling from the moment you walk in. Everything is very well maintained, clean, organized, and the overall atmosphere feels calm and professional. You can tell they genuinely care about both pets and pet parents.\n\nThe grooming service was one of the best parts of the experience. They handled everything with a lot of patience and care, and the results were amazing.\n\nOverall, the team has built a clinic that feels premium yet warm and welcoming at the same time. The care and attention they give really stand out.",
  },
  {
    id: 4,
    name: 'Samriddhi Khandelwal',
    initial: 'S',
    rating: 5,
    short: 'We took Doodle in with a suspected tick fever case. The doctor handled everything with so much calmness and patience...',
    full: "Had a really reassuring experience at Ichi and Ori Pet Care. We took Doodle in with a suspected tick fever case, and naturally we were very stressed and anxious. The doctor handled everything with so much calmness and patience. He explained every detail clearly, from the symptoms and tests to the treatment process, without creating panic.\n\nWhat stood out the most was how caring and attentive the entire team was towards Doodle. They treated him gently and made us feel supported throughout the visit. It's rare to find a vet who not only knows their job well but also understands how worried pet parents can feel in situations like this.\n\nThe clinic was clean, well managed, and the overall experience felt professional and compassionate. Truly grateful for the care, guidance, and reassurance we received.",
  },
  {
    id: 5,
    name: 'Pratyush Dhoundiyal',
    initial: 'P',
    rating: 5,
    short: "I've had the pleasure of knowing Vivek both personally and professionally for many years. His love for pets is...",
    full: "I've had the pleasure of knowing Vivek both personally and professionally for many years now, and his love for pets is truly contagious. Ichi and Ori Pet Care isn't just a business—it's a warm, affectionate home where your pets are genuinely cared for.\n\nI trust Vivek with my pets even more than I trust myself. Couldn't recommend him highly enough.",
  },
];

export const FAQS = [
  { num: '01', question: 'Do I need an appointment before visiting?', answer: 'Yes, appointments help us give your pet undivided attention and minimise waiting. Emergencies are always seen on priority. Book online, on WhatsApp or by calling +91 9560925999.' },
  { num: '02', question: 'Do you treat both dogs and cats?', answer: 'Yes, we provide veterinary care, grooming and day boarding for dogs, cats and rabbits, from puppies and kittens through to senior pets.' },
  { num: '03', question: 'What vaccinations do puppies need?', answer: 'Puppies typically start their vaccination schedule between 6 and 8 weeks of age with DHPPi-L, Anti-Rabies and Kennel Cough (Bordetella), followed by boosters as per WSAVA-guided protocols. We tailor the plan to your puppy’s age, breed and lifestyle.' },
  { num: '04', question: 'What vaccinations do kittens need?', answer: 'Kittens usually begin vaccinations between 6 and 8 weeks with FVRCP and Anti-Rabies, followed by boosters. FeLV is added where indicated. We build the schedule around your kitten’s lifestyle and medical history.' },
  { num: '05', question: 'Do you perform surgeries?', answer: 'Yes, we perform routine and select emergency surgeries including spaying, neutering, tumour removal, wound repair and aural hematoma correction, supported by careful anaesthesia protocols and structured post-operative care.' },
  { num: '06', question: 'What diagnostics are available at the clinic?', answer: 'In-house we run Digital DR X-Ray, CBC, ECG, blood pressure monitoring and microscopy for ear, skin and stool samples. For deeper investigations we work with accredited partner laboratories for biochemistry, urine analysis and histopathology.' },
  { num: '07', question: 'Do you offer home visits?', answer: 'Home veterinary visits are currently not available. All consultations, diagnostics and treatments are handled at our clinic in Sector 90, Noida, where your pet gets access to full in-house diagnostics and a proper sterile setting.' },
  { num: '08', question: 'Which areas do you serve?', answer: 'Pet parents visit us from across Noida (Sectors 90, 93, 104, 137, 143, 168 and nearby), Greater Noida, Ghaziabad, Indirapuram, Vaishali and Crossings Republik. We are conveniently located at G11, Tower C, Noida World One, Sector 90.' },
  { num: '09', question: 'What are your consultation timings?', answer: 'We are open every day from 10:30 AM to 8:00 PM. Same-day urgent consultations are accommodated during clinic hours whenever possible.' },
  { num: '10', question: 'Can I contact the clinic through WhatsApp?', answer: 'Yes, WhatsApp is the easiest way to reach us for appointment requests, post-visit follow-ups and quick questions. Message us on +91 9560925999 and our team will respond promptly.' },
];

// ---------- FORMS ----------
export const PET_TYPES = ['Dog', 'Cat', 'Bird', 'Rabbit', 'Other'];
export const SERVICE_OPTIONS = ['Veterinary', 'Grooming', 'Day Boarding', 'Retail / Products', 'General Enquiry'];

// ---------- TRUST SECTIONS ----------
export const WHY_CHOOSE_US = [
  { icon: 'Heart', title: 'Built by Passionate Pet Parents', text: 'Ichi & Ori was born from love and loss. Every decision we make is rooted in two decades of personal pet parenting experience.' },
  { icon: 'Sparkles', title: 'Personalised Care', text: 'No two pets are alike. We tailor every service to your pet’s unique personality, temperament and needs.' },
  { icon: 'Stethoscope', title: 'Experienced Veterinary Support', text: 'Led by Dr. Vivek Sheoran — SAVA, WSAVA and Ocean Park Hong Kong trained. Clinical expertise with genuine compassion.' },
  { icon: 'ShieldCheck', title: 'Safe Grooming & Boarding', text: 'Clean, climate-controlled facility with low-stress handling, dedicated bath stations and individual boarding suites.' },
  { icon: 'BadgeCheck', title: 'Compassionate & Transparent', text: 'Honest pricing, clear communication and care plans that respect both your pet and your peace of mind.' },
];

// Credible, honest stats only. Replace with verified numbers as you grow.
export const STATS = [
  { value: '500+', label: 'Pets Served' },
  { value: '107+', label: 'Google Reviews' },
  { value: '4.9★', label: 'Google Rating' },
  { value: '4', label: 'Premium Services' },
];

export const SERVICE_AREAS = [
  'Noida', 'Greater Noida', 'Ghaziabad', 'Indirapuram', 'Vaishali',
  'Crossings Republik', 'Sector 90 – 150 Noida', 'Noida Expressway',
];

// ---------- GALLERY (categorised) ----------
export const GALLERY_GROUPS = [
  { title: 'Happy Pets', images: PHOTOS.happyPets },
  { title: 'Grooming', images: PHOTOS.grooming },
  { title: 'Veterinary & Team', images: PHOTOS.team },
  { title: 'Boarding Suites', images: PHOTOS.boarding },
  { title: 'Retail / Products', images: PHOTOS.retail },
  { title: 'Our Facility', images: [...PHOTOS.facility, ...PHOTOS.storefront] },
];

export const GALLERY = GALLERY_GROUPS.flatMap((g) => g.images);

// ---------- WHY WE STARTED (homepage emotional teaser) ----------
export const WHY_STARTED = {
  tag: 'Why We Started Ichi & Ori',
  title: 'Born from love, built for every pet parent who knows what it means.',
  paragraphs: [
    'Ichi & Ori isn’t just a pet care center — it’s the result of two decades of being a devoted pet parent. Of raising pets like children. Of facing every challenge a pet parent faces. And of losing three of the most precious beings in life within six months.',
    'Out of that grief came purpose: to create the kind of pet care experience we always wished existed — one rooted in compassion, transparency and genuine understanding of what it feels like to be a pet parent.',
  ],
  image: PHOTOS.happyPets[10],
};
